import styled from "@rentiohq/shared-frontend/dist/components/theme/styled-components";
import CONFIG from "@rentiohq/shared/dist/config/app.config";
import { transparentize } from "polished";

export const LisWrap = styled.div`
  margin-top: 24px;
  padding-left: 0px;
  padding-right: 0px;
`;

export const ListItemSelectWrap = styled.div<{ selected?: boolean }>`
  background-color: ${props => {
    if (props.selected === undefined) return "transparent";
    if (props.selected) return transparentize(0.9, props.theme.colors.global5);
    return transparentize(0.5, props.theme.colors.global4);
  }};
  @media ${CONFIG.RESPONSIVE.BREAKPOINT.DESKTOP} {
    padding-left: 24px;
    padding-right: 24px;
  }
`;

export const ButtonBasicWrap = styled.div`
  margin-left: 16px;
  margin-right: 16px;
`;

export const ButtonPrimaryWrap = styled.div`
  margin-left: 16px;
  margin-right: 16px;
  @media ${CONFIG.RESPONSIVE.BREAKPOINT.DESKTOP} {
    margin-left: 40px;
    margin-right: 40px;
  }
`;
